import * as $ from 'jquery';

export default class ArticleListing {
	/**
	 *
	 * @param {function} callback
	 * @param {boolean} [immediate=false] - If `immediate` is set to true, the callback function is called on the leading edge and at the end of the interval if an event happens since first event but not during waiting period. If false, called at the end of each interval and not at the start.
	 * @param {number} [timeout] - The interval in ms to use to debounce. If not specified, the debouncer uses requestAnimationFrame.
	 */
	constructor() {
		const $form: any = $('#blog-filter');
		if ($form.length > 0) {
			$form.on('change', 'select', function() {
				$form.submit();
			});
		}
	}
}